import makeRequest from 'api/makeRequest';
import environment from 'environment';

export const getProducts = async (params) => {
  return await makeRequest(`${environment.eCommerce.PRODUCTS_BASE_URL}/products`, {
    params,
  });
};
